"use strict";
import { useQuery } from "@tanstack/react-query";
import { isDelegatedEOA } from "features/smartWallet/delegation/isDelegatedEOA";
import { ensure0xHex } from "utils/hex";
import { usePublicClient } from "wagmi";
export function useIsSmartContractWallet(address, chainId) {
  const publicClient = usePublicClient({ chainId });
  const { data, isLoading } = useQuery({
    queryKey: ["isSmartContractWallet", chainId, address],
    queryFn: async () => {
      if (!address || !publicClient) {
        return false;
      }
      const code = await publicClient.getBytecode({ address });
      if (!code || code === "0x") {
        return false;
      }
      const delegation = isDelegatedEOA({ bytecode: ensure0xHex(code) });
      return !delegation.isDelegated;
    },
    enabled: Boolean(address && publicClient),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
  return { isSmartContract: Boolean(data), isLoading };
}
